/**
 * Cleans an object by removing `undefined` or falsy values based on the provided options.
 *
 * @param {Object} obj - The input object to be cleaned.
 * @param {Object} [opts={}] - Options to control the cleaning process.
 * @param {boolean} [opts.strict=false] - If `true`, only removes keys with `undefined` values; if `false`, removes keys with falsy values except `false` and `0`.
 * @returns {Object} - A new object with only the desired key-value pairs.
 *
 * @example
 * const original = { a: 1, b: undefined, c: 0, d: false, e: '' };
 * const cleaned = cleanObject(original);
 * // cleaned: { a: 1, c: 0, d: false }
 *
 * @example
 * const original = { a: 1, b: undefined, c: 0, d: false, e: '' };
 * const cleanedStrict = cleanObject(original, { strict: true });
 * // cleanedStrict: { a: 1, c: 0, d: false, e: '' }
 */
export const cleanObject = (obj, opts = {}) => {
  const output = {};
  for (const key in obj) {
    if (opts.strict === true) {
      if (obj[key] !== undefined) {
        output[key] = obj[key];
      }
    } else {
      if (!!obj[key] || obj[key] === false || obj[key] === 0) {
        output[key] = obj[key];
      }
    }
  }
  return output;
};
